export default __webpack_public_path__ + "static/media/play-icon-white.c69839a2.svg";